
type State = {
    keyword: string;
    page: number;
    limit: number;
}
   


export const DEFAULT_PARAMS = {
    page: 1,
    limit: 10
}
export const CHANGE_PAGINATION = 'CHANGE_PAGINATION' 
export const CHANGE_NAME = 'CHANGE_NAME' 


type ChangePagination = { type: "CHANGE_PAGINATION"; payload: { page: number; limit: number }  };
type ChangeKeyword = { type: "CHANGE_NAME"; payload: string };

type ACTIONTYPE = ChangePagination | ChangeKeyword | any;

export function pageReducer(state: State, action: ACTIONTYPE) {
  switch (action.type) {
    case "CHANGE_PAGINATION":
      return {
        ...state,
        ...action.payload
      };
    case "CHANGE_NAME":
      return {
        ...state,
        keyword: action.payload,
      };
  }
}

